import * as angular from 'angular';
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {BranchesDialogService} from "../../../branches/services/branches-dialogs-service.service";
import {DeliveriesAlertsService} from "../../services/deliveries-alerts.service";
import {DeliveriesService} from "../../services/deliveries-service.service";
import {ServicesService} from "../../services/services-service.service";
import {
  CancellationReasonsDialogsService
} from "../../../cancellation-reasons/services/cancellation-reasons-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {Service} from "../../models/service.model";
import {ServicesFacadeService} from "../../angular/services/services-facade.service";
import {Subscription} from "rxjs";
import {
  ActionReasonsDialogsServiceService
} from "../../../action-reasons/services/action-reasons-dialogs-service.service";
import {ActionReasonModel} from "../../../action-reasons/models/action-reason.model";
import {ActionReasonEnum} from "../../../action-reasons/enums/action-reason.enum";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";
import * as moment from "moment";

export class ServiceViewCtrl implements IController {
  service: Service;
  serviceId: string;
  billing: any;

  public deliveryRef: any;
  public totalExpensesPrice: number;
  private isBackInStore: any;
  public serviceSubscription: Subscription;
  public agentsRef: any;
  public actionReasonTypes: typeof ActionReasonEnum = ActionReasonEnum;
  public hasRevertedTask: boolean;

  /* @ngInject */
  constructor(private actionReasonsDialogsService: ActionReasonsDialogsServiceService, private deliveriesService: DeliveriesService, private branchesDialogService: BranchesDialogService,
              private $log, private deliveriesAlertsService: DeliveriesAlertsService, private servicesService: ServicesService, private confirmDialogService: ConfirmDialogService,
              private bringozLoaderService: BringozLoaderService, private $delivery, private servicesFacadeService: ServicesFacadeService, private $timeout: ITimeoutService, private $agents,
              private analyticsService: AnalyticsService) {
  }

  $onInit() {

    this.servicesFacadeService.subscribeToChannels();
    this.agentsRef = this.$agents();

    this.servicesFacadeService.getOne(this.serviceId, true);

    this.serviceSubscription = this.servicesFacadeService.selectOne(this.serviceId).subscribe((service: Service) => {
      if (!!service) {
        this.service = angular.copy(service);

        this.setShowRevertIndicationValue();
        if (!!this.service.agentReference) {
          this.agentsRef.$asyncValues([this.service.agentReference.id])
            .then((agents) => {
              this.service.agent = agents[0];
            });
        }

        this.isBackInStore = !!_.get(this.service, 'tagNames', []).includes('Back in store');
        const diffInMonths = moment().diff(moment(service.notAfter), "months");
        this.analyticsService.trackEvent('Deliveries View', 'View', `not_after_${diffInMonths}_month`);
        this.$timeout(0).then(() => {
        });
      }
    })

    this.deliveryRef = this.$delivery(this.serviceId);
  }

  $onDestroy() {
    this.serviceSubscription.unsubscribe();
    this.servicesFacadeService.removeByIds([this.service.id]);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onBackInStore($event) {
    this.actionReasonsDialogsService.changeToBackInStore($event)
      .then((backInStoreReason) => {
        this._backInStore(backInStoreReason);
      })
  }

  onUpdateBranches(branchIds = []) {

    this.branchesDialogService.branchesSelect(event, undefined, angular.copy(branchIds))
      .then((changedBranchIds) => {
        if (!_.isEqual(changedBranchIds, branchIds)) {
          this._deliveryBranchesChanged(changedBranchIds);
        }
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      })
  }

  private _deliveryBranchesChanged(branchIds) {
    this.confirmDialogService.confirm('Change Branches', 'Are you sure you want to change branches?', event)
      .then(() => {
        this._updateDeliveryBranches(branchIds);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed', error);
      })
  }

  private _updateDeliveryBranches(branchIds) {
    let originalServiceCopy = angular.copy(this.service);
    _.set(originalServiceCopy, 'branchIds', branchIds);
    _.set(originalServiceCopy, 'manualBranches', true);

    this.bringozLoaderService.on();
    this.deliveryRef.$update(originalServiceCopy, {}, {})
      .then(() => {
        this.deliveriesAlertsService.updateDeliverySuccess(originalServiceCopy);
      })
      .catch((error) => {
        if (error) {
          if (error.code === 400301) {
            this.deliveriesAlertsService.outOfServiceZoneError();
          } else {
            this.deliveriesAlertsService.updateDeliveryError();
          }
          this.$log.error('createOrderFlowError', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });
  }

  private _backInStore(backInStoreReason) {
    this.deliveriesService.changeToBackInStore(backInStoreReason, this.service.id)
      .then(() => {
        this.isBackInStore = true;
      })
  }

  private setShowRevertIndicationValue() {
    const tasksActionReasons: ActionReasonModel[] = _.compact(_.flatMap(this.service.taskList, 'actionReasons'));

    for (let i = 0; i < tasksActionReasons.length; i++) {
      if (tasksActionReasons[i].type === this.actionReasonTypes.Revert) {
        this.hasRevertedTask = true;
        break;
      }
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceView', {
    bindings: {
      serviceId: '<'
    },
    template: require('./service-view.html').default,
    controller: ServiceViewCtrl
  });

